import clsx from 'clsx'
import Box from 'components/Box/Box'
import { IRobotInfo } from 'utils/interfaces'

import FacilityItem, { IFacilityInfo } from './FacilityItem/FacilityItem'

import style from './FacilityTable.module.css'

const FacilityTable = ({
  facilities,
  onFacilitiesUpdated,
  robots,
}: {
  facilities: IFacilityInfo[]
  onFacilitiesUpdated: () => void
  robots: IRobotInfo[]
}) => {
  return (
    <Box className={style.box}>
      <div className={style.tableWrapper}>
        <div className={style.tableHeader}>
          <div></div>
          <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>ID</div>
          <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Name</div>
          <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Type</div>
          <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Address</div>
          <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Assets</div>
          <div></div>
        </div>
        {facilities.length ? (
          <div className={style.table}>
            {facilities.map(facility => (
              <FacilityItem
                key={facility.id}
                facility={facility}
                onFacilitiesUpdated={onFacilitiesUpdated}
                robots={robots}
              />
            ))}
          </div>
        ) : (
          <div className={style.emptyWrapper}>
            <div className={style.emptyTitle}>There are no facilities</div>
          </div>
        )}
      </div>
    </Box>
  )
}

export default FacilityTable
